import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { isEmpty } from "lodash"

import InputField from "components/input"
import SubmitNotification from "components/common/submit-notification"

import { AUTH_TYPES } from "constants/auth-types"

import { loginUser, showAuthModal } from "store/auth/action"
// Import Styles
import "styles/components/auth/auth.scss"
import CheckBox from "../checkbox"
import Facebook from "./facebookLogin"
import Google from "./googleLoginForm"
// import Wallet from "./walletLogin"
import Button from "../common/Button"

export class Login extends Component {
  constructor() {
    super()

    this.state = {
      authForm: {
        username: "",
        password: "",
        keepLoggedIn: false,
      },
      fieldErrors: {},
      type: "password",
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      auth: { errors },
    } = this.props

    const {
      auth: { errors: prevErrors },
    } = prevProps

    if (errors !== prevErrors) {
      this.setState({ fieldErrors: errors })
    }
  }
  keepToggle = (e) => {
    const { authForm } = this.state
    this.setState((prevState) => ({
      authForm: {
        ...authForm,
        keepLoggedIn: !prevState.authForm.keepLoggedIn,
      },
    }))
  }

  handleChange = (e) => {
    const { authForm } = this.state
    const { name, value } = e.currentTarget
    this.setState(
      {
        authForm: {
          ...authForm,
          [name]: value,
        },
      },
      () => {
        this.validateField(name)
      }
    )
  }

  validateField = (fieldName) => {
    let fieldErrors = this.state.fieldErrors
    //add more validations
    if (isEmpty(fieldErrors[fieldName])) {
      fieldErrors.fieldName = "This field is required"
    } else {
      delete fieldErrors[fieldName]
    }
    this.setState({ fieldErrors })
  }

  handleLogin = (e) => {
    e.preventDefault()
    const { loginUser } = this.props
    const { authForm } = this.state
    loginUser(authForm)
  }

  handleShowPassword = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { type } = this.state
    this.setState({
      type: type === "text" ? "password" : "text",
    })
  }

  handleShowPassword = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { type } = this.state
    this.setState({
      type: type === "text" ? "password" : "text",
    })
  }

  render() {
    const { authForm, fieldErrors, type } = this.state

    const {
      auth: { errors },
      school: { schoolData },
      showAuthModal,
    } = this.props

    const isFacebookEnabled = schoolData?.config?.products?.facebook_sso
    const isGoogleEnabled = schoolData?.config?.products?.google_sso

    return (
      <>
        <form className="login-details" onSubmit={this.handleLogin}>
          <h1 className="title">Welcome back!</h1>
          <h3 className="subtitle">Sign in with your credentials</h3>
          <SubmitNotification
            type={
              errors && (errors.non_field_errors || errors.message) && "FAILED"
            }
            message={errors && (errors.non_field_errors || errors.message)}
          />
          <InputField
            label="Username or Email"
            name="username"
            required={true}
            value={authForm["username"]}
            error={fieldErrors["username"]}
            onChange={this.handleChange}
          />
          <InputField
            label="Password"
            name="password"
            required={true}
            type={type}
            value={authForm["password"]}
            error={fieldErrors["password"]}
            appendIcon={
              <span
                style={{
                  cursor: "pointer",
                  float: "right",
                  marginTop: "-40px",
                  marginRight: "16px",
                  position: "relative",
                  zIndex: "2",
                }}
                className={
                  type === "text" ? "icon-showpassword" : "icon-hidepassword"
                }
                onClick={this.handleShowPassword}
              />
            }
            onChange={this.handleChange}
          />
          <CheckBox
            text="Keep me logged in"
            value={authForm.keepLoggedIn}
            onClick={this.keepToggle}
            id="chk-keep-login"
          />
          <Button
            label="Login account"
            block
            size="medium"
            type="submit"
            customClassName={"auth-button"}
          />
        </form>
        {(isFacebookEnabled || isGoogleEnabled) && (
          <div className="login-option">or login with</div>
        )}
        <div className="login-buttons">
          {/* <Wallet /> */}
          {isFacebookEnabled && <Facebook />}
          {isGoogleEnabled && <Google />}
        </div>
        <div style={{ marginTop: "24px" }} className="meta-links">
          <label
            className="link"
            onClick={() => showAuthModal({ type: AUTH_TYPES.FORGOT_PASSWORD })}
          >
            Forgot Password?
          </label>
          <label
            className="link"
            onClick={() => showAuthModal({ type: AUTH_TYPES.REGISTER })}
          >
            Don't have an account?
          </label>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginUser,
      showAuthModal,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(Login)
